
import { cn } from "@/lib/utils";

interface ScoreGaugeProps {
	score?: number;
	size?: number;
	className?: string;
}

export const ScoreGauge = ({ score, size = 200, className }: ScoreGaugeProps) => {
	if (typeof score !== 'number') return null;

	// Calculate the color based on score
	const getColor = (score: number) => {
		if (score <= 40) return 'from-red-500 to-red-600';
		if (score <= 69) return 'from-orange-400 to-orange-500';
		return 'from-green-400 to-green-500';
	};

	// Calculate the percentage for the circle
	const percentage = (score / 100) * 360;
	
	return (
		<div className={cn("relative", className)}>
			{/* Background circle */}
			<div 
				className="w-full h-full rounded-full bg-gray-100"
				style={{ width: size, height: size }}
			/>
			{/* Colored circle based on score */}
			<div 
				className={cn(
					"absolute top-0 left-0 w-full h-full rounded-full bg-gradient-to-r",
					getColor(score)
				)}
				style={{
					width: size,
					height: size,
					clipPath: `polygon(50% 50%, 50% 0%, ${percentage <= 180 
						? `${50 + 50 * Math.sin(percentage * Math.PI / 180)}% ${50 - 50 * Math.cos(percentage * Math.PI / 180)}%`
						: '100% 0%, 100% 100%, 0% 100%, 0% 0%'
					})`
				}}
			/>
			{/* Score text */}
			<div 
				className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-4xl font-bold"
			>
				{Math.round(score)}
			</div>
		</div>
	);
};
